import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { routeHistory } from 'biw-web-router';

export const Link = ( props ) => {
    // Construct the classes to use for the root component.
    const classes = classnames(
        'link',
        { [ props.className ]: Boolean( props.className ) },
    );

    const handleClick = useCallback( () => {
        let path = props.to;

        // If a function is provided for the `to` property, call it expecting
        // a string to be returned to get the new path to navigate to.
        if ( typeof props.to === 'function' ) {
            const previousRouteParams = routeHistory?.route?.state?.params;
            path = props.to( previousRouteParams ? previousRouteParams : {} );
        } 

        if ( props.back ) {
            routeHistory.back();
        } else if ( props.replace ) {
            routeHistory.replace( path, { props: props.toProps } );
        } else {
            routeHistory.push( path, { props: props.toProps } );
        }

        // Execute click callback if provided.
        if ( props.onClick ) {
            props.onClick();
        }
    }, [ props ] );

    return (
        <span id={ props.id } className={ classes }>
            <a
                href={ props.href }
                target={ props.newTab ? '_blank' : undefined }
                rel={ props.newTab ? 'noopener noreferrer' : undefined }
                onClick={ handleClick }
            >
                { props.children }
            </a>
        </span>
    );
};

Link.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    to: PropTypes.string,
    href: PropTypes.string,
    toProps: PropTypes.object,
    newTab: PropTypes.bool,
    replace: PropTypes.bool,
    back: PropTypes.bool,
    onClick: PropTypes.func,
};
